import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { VehicleListItemViewModel } from '../vehicles-list/vehicles-list.component';
import { YesCancelModalComponent } from '../modals/yes-cancel-modal/yes-cancel-modal.component';
import { PermitService, PermitDetailsVehicleItemModel } from '../services/permit.service';
import { ErrorHandlingService, AlertService } from 'core-lib';
import { environment } from '../../environments/environment';
import { FileUploadComponent, FileListItemModel } from '../components/file-upload/file-upload.component';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'cli-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss']
})
export class VehicleDetailsComponent implements OnInit {

  @Input()
  vehicle: VehicleListItemViewModel;

  @ViewChild('requestRemovalModal')
  requestRemovalModal: YesCancelModalComponent;

  @ViewChild('fileUploadComponent')
  fileUploadComponent: FileUploadComponent;

  constructor(private permitSvc: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private alertSvc: AlertService,
    private router: Router) { }

  ngOnInit() {
  }

  public requestRemoval() {

    this.requestRemovalModal.openModal().toPromise().then((r: string) => {

      if (r === 'Yes') {

        this.permitSvc.requestVehicleRemoval(this.vehicle.vehicleId).toPromise().then(() => {

          this.vehicle.isRemovalRequested = true;

          this.alertSvc.success(environment.TOASTR_HEADER, 'The request to remove the vehicle was submitted');
        },
          (e) => {
            this.errorHandlingSvc.processHttpError(e);
          });
      }


    }, (e) => { });
  }

  public uploadCertificate() {
    this.fileUploadComponent.openFileDialog();
  }

  public editVehicle() {
    this.router.navigate(['app/vehicle-edit/' + this.vehicle.vehicleId]);
  }

  public onFileUploaded(e: FileListItemModel) {
    let v: PermitDetailsVehicleItemModel = _.find(this.permitSvc.model.vehicles, (v: PermitDetailsVehicleItemModel) => {
      return v.vehicleId == this.vehicle.vehicleId;
    });

    let a = {fileId: e.fileId,
             fileName: e.fileName,
            contentType: e.contentType,
            dateCreated: e.dateCreated};
            
    v.attachments.push(a);

  }

  public onFileRemoved(e: FileListItemModel) {
    let v: PermitDetailsVehicleItemModel = _.find(this.permitSvc.model.vehicles, (v: PermitDetailsVehicleItemModel) => {
      return v.vehicleId == this.vehicle.vehicleId;
    });

    v.attachments = _.filter(v.attachments, (a) => {
      return a.fileId != e.fileId;
    });

  }
}
